"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronTriggerFactoryFromJS = exports.CronTriggerFactory = void 0;
const immutable_1 = require("immutable");
const enums_1 = require("../../enums");
const bases_1 = require("../bases");
exports.CronTriggerFactory = (0, immutable_1.Record)(Object.assign(Object.assign({}, (0, bases_1.TriggerFactory)().toJS()), { type: enums_1.ETriggerType.Cron, expression: '', missFireRule: enums_1.ETriggerMissfireRules.DoNothing, timeZone: '' }));
const CronTriggerFactoryFromJS = function (data) {
    return (0, exports.CronTriggerFactory)(Object.assign(Object.assign({}, (0, bases_1.TriggerFactoryFromJS)(data).toJS()), { expression: data.expression, missFireRule: data.missFireRule, timeZone: data.timeZone }));
};
exports.CronTriggerFactoryFromJS = CronTriggerFactoryFromJS;
//# sourceMappingURL=ICronTrigger.js.map